import React from "react";
import { HelpScoutUrls } from "../../utils/helpScoutUrls";
import { ColorClassNames } from "../../Colors";

import { LegalDisclaimer, LegalDisclaimerPropsWithoutContent } from "../LegalDisclaimer";

const content = (
  <>
    <p>
      Additional Savings Disclaimer: For illustrative purposes only. This is not a prediction or guarantee of future
      performance. Data as of 01/01/2016.{" "}
      <a
        data-name="DisclaimerLandingPageLearnMore"
        className={`${ColorClassNames.mint} bold`}
        href={HelpScoutUrls.consolidationGrowthCalculationMethodology}
        rel="noopener noreferrer"
        target="_blank"
      >
        Learn more
      </a>
      .
      <br />
      <br />
      ManifestHQ Advisors, LLC is a wholly owned subsidiary of ManifestHQ, Inc. and a SEC-registered investment adviser.
      Registration does not imply a certain level of skill or training nor does it imply endorsement by the SEC. Please
      see our{" "}
      <a
        data-name="DisclaimerLandingPageTermsOfService"
        className={`${ColorClassNames.mint} bold`}
        href={HelpScoutUrls.termsOfService}
        rel="noopener noreferrer"
        target="_blank"
      >
        Terms of Service
      </a>
      ,{" "}
      <a
        data-name="DisclaimerLandingPageFormADV"
        className={`${ColorClassNames.mint} bold`}
        href={HelpScoutUrls.formADV}
        rel="noopener noreferrer"
        target="_blank"
      >
        Form ADV
      </a>
      , and{" "}
      <a
        data-name="DisclaimerLandingPageFormCRS"
        className={`${ColorClassNames.mint} bold`}
        href={HelpScoutUrls.formCRS}
        rel="noopener noreferrer"
        target="_blank"
      >
        Form CRS
      </a>{" "}
      for further details.
      <br />
      <br />
      Awards and recognitions listed in this website or on our application should not be interpreted as a guarantee or
      suggestion that anyone will experience a certain level of results if our firm is engaged, or continues to be
      engaged, to provide services, or as an endorsement of our firm by anyone. None of the sponsoring publications or
      organizations are affiliated with our firm, none of the awards or recognitions listed are based on others’
      evaluations of our firm.
      <br />
      <br />
      ManifestHQ Advisors, LLC, 1452 E. 53rd Street, Chicago, Illinois 60615
      <br />© ManifestHQ Advisors, LLC. All rights reserved.
    </p>
  </>
);

export default function DisclaimerLandingPage(props: LegalDisclaimerPropsWithoutContent) {
  return <LegalDisclaimer {...props} content={content} />;
}
